import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import SobeysSkusForm from "../../../components/forms/setup/sobeysSkus/SobeysSkusForm";
import { BannerNotificationType } from "../../../components/SimpleBanner";

export function SobeysSkusViewModel(logout) {
  const [loading, setLoading] = useState(false);
  const [sobeysSkus, setSobeysSkus] = useState({ data: [] });

  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const user_id = localStorage.getItem("id");

  const getSobeysSkus = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`sunSobeysSkus`, payload);
    setLoading(false);
    if (callResult.success) {
      setSobeysSkus(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createSobeysSku = async function (values) {
    const payload = { ...values, user_id: user_id };
    let callResult = await makePostApiCall("createSunSobeysSku", payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Sobeys SKU added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getSobeysSkus("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateSobeysSku = async function (sobeysSku, values, index) {
    const payload = { ...values, id: sobeysSku.id };
    let callResult = await makePutApiCall(`sunSobeysSkus/${sobeysSku.id}`, payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Sobeys SKU updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getSobeysSkus("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddSobeysSkuSlideOver = () => {
    setSlideOver({
      childComponent: (
        <SobeysSkusForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createSobeysSku}
        />
      ),
      open: true,
    });
  };

  const viewSobeysSkuDetails = async function (sobeysSku, index) {
    setSlideOver({
      childComponent: (
        <SobeysSkusForm
          sobeysSku={sobeysSku}
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          actionCall={updateSobeysSku}
        />
      ),
      open: true,
    });
  };

  return {
    getSobeysSkus,
    loading,
    sobeysSkus,
    openAddSobeysSkuSlideOver,
    setSlideOver,
    setShowSimpleNotification,
    slideOver,
    showSimpleNotification,
    viewSobeysSkuDetails,
  };
}
